module.exports = __webpack_public_path__ + "static/mouse-middle.9a1385706c1d8c400b85e193bdd3f5e8.svg";